import { createVoiceLiveInspectorSender, type VoiceLiveInspectorSender } from '../inspector/sender';

let inspector: VoiceLiveInspectorSender | undefined;

/**
 * Opt-in live inspector for the Voice Live machine.
 *
 * Returns an XState `inspect` observer when the URL has exactly `?inspect=1`. The
 * observer opens a same-origin FieldOne route and streams a sanitized, memory-only
 * transition history over BroadcastChannel. It never connects to Stately.
 *
 * Access is enforced on the `/support/voice-live-inspector` route, which requires the
 * maintainer role — the stream is unreadable without it.
 *
 * Existing Application Insights telemetry remains independent and continues to
 * capture the application's curated operational events and exceptions.
 */
export const getVoiceLiveInspect = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  if (new URLSearchParams(window.location.search).get('inspect') !== '1') {
    return undefined;
  }
  if (!inspector) {
    inspector = createVoiceLiveInspectorSender();
  }
  return inspector?.inspect;
};
